interface OnbTableSortOptions {
  column: string;
  sortBy: string[];
  sortOrder: string;
}

interface OnbTableColumnDefinition {
  dataColumns: string[],
  columnName: string,
  isSortable: boolean,
  i18nLabel: string,
  thCssClass?: string
}

/**
 * Welche Spalten sollen in der Tabelle Legal entities angezeigt werden
 */
 const LEGAL_ENTITIES_SORT_VALUES = [
  { dataColumns: [ 'name' ], sortString: 'name', columnName: "name", isSortable: true, i18nLabel: "views.legalEntities.sortColumns.name"} as OnbTableColumnDefinition,
  { dataColumns: [ 'address.zipCode', 'address.streetName' ], sortString: 'address.zipCode', columnName: "address", isSortable: true, i18nLabel: "views.legalEntities.sortColumns.address", thCssClass: "d-none d-sm-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'status' ], sortString: 'status', columnName: "status", isSortable: true, i18nLabel: "views.legalEntities.sortColumns.status", thCssClass: "d-none d-md-table-cell" } as OnbTableColumnDefinition,
] as OnbTableColumnDefinition[]

/**
 * Spalten der Datentabelle Counseling Centers
 */
const COUNSELING_CENTERS_SORT_VALUES = [
  { dataColumns: [ 'name' ], sortString: 'name', columnName: "name", isSortable: true, i18nLabel: "views.counselingCenters.sortColumns.name" } as OnbTableColumnDefinition,
  { dataColumns: [ 'address.zipCode', 'address.streetName' ], sortString: 'address.zipCode', columnName: "address", isSortable: true, i18nLabel: "views.counselingCenters.sortColumns.address", thCssClass: "d-none d-sm-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'legalEntities' ], sortString: 'legalEntities', columnName: "legalEntities", isSortable: true, i18nLabel: "views.counselingCenters.sortColumns.legalEntities", thCssClass: "d-none d-md-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'phone' ], sortString: 'phone', columnName: "phone", isSortable: true, i18nLabel: "views.counselingCenters.sortColumns.phone", thCssClass: "d-none d-lg-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'status' ], sortString: 'status', columnName: "status", isSortable: true, i18nLabel: "views.counselingCenters.sortColumns.status", thCssClass: "d-none d-lg-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'online' ], sortString: 'online', columnName: "online", isSortable: false, i18nLabel: "views.counselingCenters.sortColumns.online", thCssClass: "d-none d-lg-table-cell" } as OnbTableColumnDefinition,
] as OnbTableColumnDefinition[]

const COUNSELING_CENTERS_ACL_SORT_VALUES = [
  { dataColumns: [ 'name' ], sortString: 'name', columnName: "name", isSortable: true, i18nLabel: "views.counselingCenters.sortColumns.name" } as OnbTableColumnDefinition,
  { dataColumns: [ 'address.zipCode', 'address.streetName' ], sortString: 'address.zipCode', columnName: "address", isSortable: true, i18nLabel: "views.counselingCenters.sortColumns.address", thCssClass: "d-none d-sm-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'legalEntities' ], sortString: 'legalEntities', columnName: "legalEntities", isSortable: true, i18nLabel: "views.counselingCenters.sortColumns.legalEntities", thCssClass: "d-none d-md-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'totalAclUsers' ], sortString: 'totalAclUsers', columnName: "totalAclUsers", isSortable: false, i18nLabel: "views.counselingCenters.sortColumns.persons", thCssClass: "d-none d-lg-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'status' ], sortString: 'status', columnName: "status", isSortable: false, i18nLabel: "views.counselingCenters.sortColumns.status", thCssClass: "d-none d-lg-table-cell" } as OnbTableColumnDefinition,
] as OnbTableColumnDefinition[]

/**
 * Spalten der Tabelle Lookup Values
 */
const LOOKUP_VALUES_NO_USAGE_SORT_VALUES = [
  { dataColumns: [ 'description.de' ], sortString: 'description', columnName: "description_de", isSortable: true, i18nLabel: "views.lookupValues.description.de" } as OnbTableColumnDefinition,
  { dataColumns: [ 'description.en' ], sortString: 'description', columnName: "description_en", isSortable: true, i18nLabel: "views.lookupValues.description.en" } as OnbTableColumnDefinition,
  { dataColumns: [ 'usage' ], sortString: 'usage', columnName: "usage", isSortable: true, i18nLabel: "views.lookupValues.usage" } as OnbTableColumnDefinition
] as OnbTableColumnDefinition[]

const LOOKUP_VALUES_USAGE_SORT_VALUES = [
  { dataColumns: [ 'description.de' ], sortString: 'description', columnName: "description_de", isSortable: true, i18nLabel: "views.lookupValues.description.de" } as OnbTableColumnDefinition,
  { dataColumns: [ 'description.en' ], sortString: 'description', columnName: "description_en", isSortable: true, i18nLabel: "views.lookupValues.description.en" } as OnbTableColumnDefinition,
  { dataColumns: [ 'usage' ], sortString: 'usage', columnName: "usage", isSortable: true, i18nLabel: "views.lookupValues.usage" } as OnbTableColumnDefinition
] as OnbTableColumnDefinition[]

const APPOINTMENTS_SORT_VALUES = [
  { dataColumns: [ 'startTime' ], sortString: 'startTime', columnName: "startTime", isSortable: true, i18nLabel: "views.legalEntities.sortColumns.name"} as OnbTableColumnDefinition,
] as OnbTableColumnDefinition[]

const PERSONS_SORT_VALUES = [
  { dataColumns: [ 'lastName' ], sortString: 'lastName', columnName: "lastName", isSortable: true, i18nLabel: "views.persons.sortColumns.lastName" } as OnbTableColumnDefinition,
  { dataColumns: [ 'firstName' ], sortString: 'firstName', columnName: "firstName", isSortable: true, i18nLabel: "views.persons.sortColumns.firstName" } as OnbTableColumnDefinition,
  { dataColumns: [ 'email' ], sortString: 'email', columnName: "email", isSortable: true, i18nLabel: "views.persons.sortColumns.email", thCssClass: "d-none d-sm-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'legalEntityName' ], sortString: 'legalEntityName', columnName: "legalEntityName", isSortable: true, i18nLabel: "views.persons.sortColumns.legalEntities", thCssClass: "d-none d-md-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'roles' ], sortString: 'roles', columnName: "roles", isSortable: false, i18nLabel: "views.persons.sortColumns.roles", thCssClass: "d-none d-md-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: ['totalCounselingCenters'], sortString: 'totalCounselingCenters', columnName: "totalCounselingCenters", isSortable: false, i18nLabel: "views.persons.sortColumns.usage", thCssClass: "d-none d-md-table-cell" } as OnbTableColumnDefinition,
] as OnbTableColumnDefinition[]

const COUNSELING_CENTER_PERSONS_SORT_VALUES = [
  { dataColumns: [ 'lastName' ], sortString: 'lastName', columnName: "lastName", isSortable: true, i18nLabel: "views.persons.sortColumns.lastName" } as OnbTableColumnDefinition,
  { dataColumns: [ 'firstName' ], sortString: 'firstName', columnName: "firstName", isSortable: true, i18nLabel: "views.persons.sortColumns.firstName" } as OnbTableColumnDefinition,
  { dataColumns: [ 'email' ], sortString: 'email', columnName: "email", isSortable: true, i18nLabel: "views.persons.sortColumns.email", thCssClass: "d-none d-sm-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'roles' ], sortString: 'roles', columnName: "roles", isSortable: false, i18nLabel: "views.persons.sortColumns.roles", thCssClass: "d-none d-md-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'permissions' ], sortString: 'permissions', columnName: "permissions", isSortable: false, i18nLabel: "views.persons.sortColumns.permissions", thCssClass: "d-none d-md-table-cell" } as OnbTableColumnDefinition,
] as OnbTableColumnDefinition[]

const PERSONS_EDIT_SORT_VALUES = [
  { dataColumns: [ 'name' ], sortString: 'name', columnName: "name", isSortable: true, i18nLabel: "common.counselingCenters", thCssClass: "d-none d-md-table-cell" } as OnbTableColumnDefinition,
  { dataColumns: [ 'permissions' ], sortString: 'permissions', columnName: "permissions", isSortable: false, i18nLabel: "views.persons.sortColumns.permissions", thCssClass: "d-none d-md-table-cell" } as OnbTableColumnDefinition,
] as OnbTableColumnDefinition[]

function createDefaultTableSortOptions(columnDefinitions: OnbTableColumnDefinition[]): OnbTableSortOptions {
  return createTableSortOptions(columnDefinitions, columnDefinitions[0].columnName)
}

function createTableSortOptions(columnDefinitions: OnbTableColumnDefinition[], column: string, descending = false): OnbTableSortOptions {
  if (!column) {
    return createDefaultTableSortOptions(columnDefinitions)
  }
  for(const columnDefinition of columnDefinitions) {
    if(columnDefinition.columnName === column) {
      return {
        column: column,
        sortBy: columnDefinition.dataColumns,
        sortOrder: descending ? 'desc' : 'asc'
      }
    }
  }
  return createDefaultTableSortOptions(columnDefinitions)
}

export {
  OnbTableSortOptions,
  OnbTableColumnDefinition,
  createDefaultTableSortOptions,
  createTableSortOptions,
  LEGAL_ENTITIES_SORT_VALUES,
  COUNSELING_CENTERS_SORT_VALUES,
  COUNSELING_CENTERS_ACL_SORT_VALUES,
  LOOKUP_VALUES_NO_USAGE_SORT_VALUES,
  LOOKUP_VALUES_USAGE_SORT_VALUES,
  APPOINTMENTS_SORT_VALUES,
  PERSONS_SORT_VALUES,
  COUNSELING_CENTER_PERSONS_SORT_VALUES,
  PERSONS_EDIT_SORT_VALUES
}
